<crowdctrl-unauthenticated-page [pageTitle]="pageTitle" [showFooter]="false" defaultHref="/login">
  <div class="about-project">
    <crowdctrl-unauth-page-intro>
      <h1 crowdctrlUnauthIntroTitle>Privacy Policy</h1>
      <p crowdctrlUnauthIntroLead>
        This policy explains how {{ appName }} handles personal information.
      </p>
    </crowdctrl-unauth-page-intro>

    <section class="about-project__section" aria-labelledby="privacy-scope">
      <h2 id="privacy-scope" class="about-project__heading">Scope</h2>
      <p class="about-project__text">
        This policy applies to personal information processed through {{ appName }} websites and
        applications. It covers account access, operational activity data, and public forms where
        those features are enabled.
      </p>
    </section>

    <section class="about-project__section" aria-labelledby="privacy-collect">
      <h2 id="privacy-collect" class="about-project__heading">Information we collect</h2>
      <ul class="about-project__list">
        <li>Identity and account information, including name, email address, and access role.</li>
        <li>Operational data, including workspace, session, queue, and form activity.</li>
        <li>Technical data, including device details, browser details, logs, and diagnostics.</li>
        <li>Communications submitted through contact or support features.</li>
      </ul>
    </section>

    <section class="about-project__section" aria-labelledby="privacy-use">
      <h2 id="privacy-use" class="about-project__heading">How we use information</h2>
      <ul class="about-project__list">
        <li>To provide, maintain, and secure the service.</li>
        <li>To authenticate users and enforce access controls.</li>
        <li>To operate workflow features and process service activity.</li>
        <li>To improve performance, reliability, and support outcomes.</li>
      </ul>
    </section>

    <section class="about-project__section" aria-labelledby="privacy-sharing">
      <h2 id="privacy-sharing" class="about-project__heading">Sharing and disclosure</h2>
      <p class="about-project__text">
        We do not sell personal information. Information may be disclosed to service providers that
        support hosting, authentication, security, and analytics, and where disclosure is required
        by law or necessary to protect users, personnel, or service integrity.
      </p>
    </section>

    <section class="about-project__section" aria-labelledby="privacy-retention">
      <h2 id="privacy-retention" class="about-project__heading">Retention and security</h2>
      <p class="about-project__text">
        Information is retained only for as long as required for operational, legal, and security
        purposes. We apply reasonable administrative, technical, and organisational safeguards. No
        method of transmission or storage can be guaranteed to be completely secure.
      </p>
    </section>

    <section class="about-project__section" aria-labelledby="privacy-rights">
      <h2 id="privacy-rights" class="about-project__heading">Your choices and rights</h2>
      <p class="about-project__text">
        Depending on applicable law, you may have rights to access, correct, delete, or restrict the
        processing of your personal information. To make a request, use
        <a
          href="/contact"
          class="about-project__inline-link"
          (click)="unauthNav.forward($event, '/contact')"
          >Contact us</a
        >.
      </p>
    </section>

    <section class="about-project__section" aria-labelledby="privacy-updates">
      <h2 id="privacy-updates" class="about-project__heading">Policy updates</h2>
      <p class="about-project__text">
        This policy may be updated from time to time. The current version is published on this page.
      </p>
    </section>
  </div>
</crowdctrl-unauthenticated-page>
